import _ from "underscore";
import DriveView, { IDriveViewOptions } from "../../DriveView";
import { Dialog } from "../framework/dialog";
import { handleApi } from "../../utils/error";
import AppView from "../../app.view";

const DETACH_TEMPLATE = `<div class="noticeBox noticeBox--type-error" id="detach-error" role="alert">
                            <div class="noticeBox__container">
                                <span class="noticeBox__title"><svg class="svgIcon big" role="img" aria-label="Attention icon"><use xlink:href="#drive-attention"></use></svg></span>
                                <span class="noticeBox__content" id="detach-message"><%- message %></span>
                            </div>
                        </div>
                        <% if (showDetachAllButton) { %>
                            <button id="driver-asset-selection-detach-all-button" class="button_secondary"><%- detachButtonText %></button>
                        <% } %>`;

interface IDetachAllParams extends IDriveViewOptions<Backbone.Model> {
    detachButtonText: string;
    getConfirmMessage: (() => string) | null;
    getDetachErrorMessage: (() => string) | null;
    detachCallback: (() => Promise<void>) | null;
    app: AppView;
}

export default class DetachAllPanelView extends DriveView<Backbone.Model> {
    private readonly template = _.template(DETACH_TEMPLATE);
    private readonly detachButtonText: string;
    private detachCallback: (() => Promise<void>) | null;
    private getConfirmMessage: (() => string) | null;
    private getDetachErrorMessage: (() => string) | null;

    constructor(options: IDetachAllParams) {
        super(options);
        this.getConfirmMessage = options.getConfirmMessage;
        this.getDetachErrorMessage = options.getDetachErrorMessage;
        this.detachCallback = options.detachCallback;
        this.detachButtonText = options.detachButtonText;
    }

    /* eslint-disable @typescript-eslint/unbound-method */
    events() {
        return {
            "click #driver-asset-selection-detach-all-button": this.detachAllConfirm
        } as Backbone.EventsHash;
    }
    /* eslint-enable @typescript-eslint/unbound-method */

    show(showDetachAllButton: boolean) {
        this.display(this.template({
            message: (this.getDetachErrorMessage && this.getDetachErrorMessage()) || "",
            showDetachAllButton,
            detachButtonText: this.detachButtonText
        })).catch(handleApi);
    }

    remove() {
        this.detachCallback = null;
        this.getConfirmMessage = null;
        this.getDetachErrorMessage = null;
        super.remove();
        return this;
    }

    private toggleDisableButton(disable: boolean) {
        let disableAllButton = document.getElementById("driver-asset-selection-detach-all-button") as HTMLButtonElement;
        disableAllButton && (disableAllButton.disabled = disable);
    }

    private detachAllConfirm() {
        let detachedNewCallback = (thisDialog: Dialog) => {
            this.toggleDisableButton(false);
            thisDialog.remove();
        };

        let detachAllWarning = new Dialog(
            "detach-all-warning",
            "",
            this.translator,
            "Confirmation Required",
            [
                [{
                    text: "Cancel",
                    className: "button_secondary",
                    id: "detach-all-cancel",
                    callback: () => detachAllWarning.remove()
                }, {
                    text: "Detach all",
                    id: "detach-all-accept",
                    spinner: true,
                    callback: thisDialog => {
                        if (this.detachCallback) {
                            this.toggleDisableButton(true);
                            this.detachCallback()
                                .then(() => detachedNewCallback(thisDialog))
                                .catch(error => {
                                    handleApi(error);
                                    detachedNewCallback(thisDialog);
                                });
                        } else {
                            detachAllWarning.remove();
                        }
                    }
                }]
            ],
            {
                isNightMode: this.app.store.getState().data.nightMode
            }
        );
        return detachAllWarning.open(this.translator)
            .then(() => {
                let warningTextContent = document.getElementById("detach-all-warning-inner");
                if (warningTextContent && this.getConfirmMessage) {
                    warningTextContent.textContent = this.getConfirmMessage();
                }
            });
    }
}